// | ------------------------------------------------------------------------
// | Components - Shop - Quick Quote Modal
// | ------------------------------------------------------------------------

import { Modal } from "bootstrap";

// | ------------------------------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
    var productsPage = document.querySelector("#quickQuote");

    if (productsPage) {
        // Set up modal
        const quoteModal = new Modal(document.getElementById("quickQuote"), {
            backdrop: false,
        });

        // Get modal element
        const quoteModalElement = document.getElementById("quickQuote");
        // Get button element
        const quoteBtn = document.getElementById("quickQuoteBtn");

        // Avoid jumping around with scrollbars when the modal opens
        quoteModalElement.addEventListener("shown.bs.modal", (event) => {
            document.body.style.overflow = "";
            document.body.style.paddingRight = "0";
            document.body.classList.remove("modal-open");
        });

        // Add button when modal closes
        if (quoteBtn) {
            quoteModalElement.addEventListener("hide.bs.modal", (event) => {
                quoteBtn.classList.remove("d-none");
            });
        }

        // Hide the modal
        function hideQuickQuote() {
            quoteModal.hide();
        }

        // Check if viewing on a desktop
        const isDesktop = window.matchMedia("(min-width: 768px)");

        if (isDesktop.matches) {
            // If so show the modal with timeout
            //FUCK OFF: quoteModal.show();

            // Remove any styles on the body we don't need
            document.body.classList.remove("modal-open");
            document.body.style.overflow = "";
            document.body.style.paddingRight = "";
            if (quoteBtn) {
                quoteBtn.classList.add("d-none");
            }
            setTimeout(hideQuickQuote, 30000);
        } else {
            // Else show the button to be able to open the modal
        }
    }
});
